import { render, staticRenderFns } from "./addtidan.vue?vue&type=template&id=f5e3654a&scoped=true&"
import script from "./addtidan.vue?vue&type=script&lang=js&"
export * from "./addtidan.vue?vue&type=script&lang=js&"
import style0 from "./addtidan.vue?vue&type=style&index=0&id=f5e3654a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e3654a",
  null
  
)

export default component.exports